import { render, staticRenderFns } from "./outboundreport_main.vue?vue&type=template&id=b3b3a88c&scoped=true"
import script from "./outboundreport_main.vue?vue&type=script&lang=js"
export * from "./outboundreport_main.vue?vue&type=script&lang=js"
import style0 from "./outboundreport_main.vue?vue&type=style&index=0&id=b3b3a88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b3a88c",
  null
  
)

export default component.exports